module.exports = __webpack_public_path__ + "static/media/spade.0b020c20.svg";